import fetch2 from "apps/rails/src/fetch2";
import { GetScheduleTatkalDetailsRequest, RegisterScheduleTatkalRequest, ScheduleTatkalReviewRequest } from "./interface";
import railsConfig from "apps/rails/src/RailsConfig";
import { getDefaultPostHeaders } from "../../NewListing/RailsListingActions";
import { _label } from "apps/rails/src/vernacular/AppLanguage";

export const getScheduleTatkalDetails = async (payload: GetScheduleTatkalDetailsRequest) => {
    try {
      const response = await fetch2(railsConfig.getScheduleTatkalDetails, {
        method: 'POST',
        headers: getDefaultPostHeaders(),
        body: JSON.stringify(payload),
      });
      const res = await response.json();
    
      return res;
    } catch (e) {
      console.error('Error in fetching schedule tatkal details from api', e);
      return {
        error: _label('something_went_wrong'),
      };
    }
};

export const registerScheduleTatkal = async (payload: RegisterScheduleTatkalRequest, formId?: string | undefined) => {
    try {
        if (formId) {
      const url = `${railsConfig.updateScheduledTatkal}?formId=${formId}`;
            const response = await fetch2(url, {
                method: 'POST',
                headers: getDefaultPostHeaders(),
                body: JSON.stringify(payload),
            });
            const res = await response.json();
            return res;
        } else {
            const response = await fetch2(railsConfig.registerScheduledTatkal, {
                method: 'POST',
                headers: getDefaultPostHeaders(),
                body: JSON.stringify(payload),
            });
            const res = await response.json();
            
            return res;
        }
    } catch (error) {
        console.error('Error in registerScheduleTatkal API', error);
        return {
            error: _label('something_went_wrong'),
        };
    };
};

export const scheduleTatkalBookingReview = async (bookingReviewRequest: ScheduleTatkalReviewRequest, bookingSource: string) => {
    try {
        let bkngSrc = bookingSource;
        if (bkngSrc && bkngSrc?.toLowerCase()?.includes?.('irctc')) {
            bkngSrc = 'IRCTC'
        }
        const headers = {
            ...getDefaultPostHeaders(),
            ...(bkngSrc && { 'booking-source': bkngSrc })
        };
        const response = await fetch2(railsConfig.bookingReviewUrl, {
            method: 'POST',
            headers,
            body: JSON.stringify(bookingReviewRequest)
        });
        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        console.error('Error in schedule tatkal bookingReview API', error);
        return {
            error: _label('something_went_wrong'),
        };
    }
};

export const getAllScheduleTatkalForms = async () => {
  try {
    const response = await fetch2(railsConfig.getAllScheduleTatkalForms, {
      method: 'GET',
      headers: getDefaultPostHeaders(),
    });
    return await response.json();
  } catch (error) {
    console.error('Error in getAllScheduleTatkalForms API', error);
    return {
      error: _label('something_went_wrong'),
    };
  }
};

export const deleteScheduleTatkalForm = async (formId: string) => {
  try {
    const response = await fetch2(`${railsConfig.deleteScheduleTatkalForm}?formId=${formId}`, {
      method: 'DELETE',
      headers: getDefaultPostHeaders(),
    });
    return response.json();
  } catch (error) {
    console.error('Error in deleteScheduleTatkalForm API', error);
    return {
      error: _label('something_went_wrong'),
    };
  }
};
